import {Component, Input, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {FormControl} from "@angular/forms";
import {Observable} from "rxjs";
import {map, startWith} from "rxjs/operators";
import {DataService} from "../../services/data.service";
import {MatAutocomplete} from "@angular/material/autocomplete";

@Component({
  selector: 'app-async-select',
  templateUrl: './async-select.component.html',
  styleUrls: ['./async-select.component.scss']
})
export class AsyncSelectComponent implements OnInit {
  filteredOptions: Observable<any[]>;
  @Input() selectorId: string = "";
  @Input() selectControl: FormControl = new FormControl();
  @Input() disabled: boolean = false;
  @Input() apiInfo: any = {};
  @Input() dependency: string = "";
  @Input() label: string = "";
  @Input() field: string = "";
  @Input() disableOptions: any[] = [];
  @Output() optionSelected = new EventEmitter();
  restApiOptions: any[] = [];
  isLoading: boolean = false;
  open: boolean = false;
  options: any[] = [];
  constructor(private dataService: DataService) { }

  ngOnInit(): void {

  }

  async loadData(e: any){
    await this.getApiOptions();
    this.filteredOptions = this.selectControl.valueChanges
      .pipe(
        startWith(''),
        map(value => {
          return typeof value === 'string' || !value ? value : value.label
        }),
        map(name => {
          return name ? this._filter(name) : this.options.slice()
        })
      );
  }

  displayFn(item: any): string {
    return item && item.label ? item.label : item;
  }

  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.options.filter(option => typeof option === "string" ? option.toLowerCase().includes(filterValue): option.label.toLowerCase().includes(filterValue));
  }

  private getApiOptions(){
    return new Promise<void>((resolve, reject) => {
      let options = [],
        {path, method, labelField, valueField, valueFieldExt} = this.apiInfo;
      if (this.dependency) {
        path = path + '/' + this.dependency.toLowerCase();
      }
      this.isLoading = true;
      this.dataService.getApiData(path, method).toPromise().then((res: any[]) => {
        res.forEach(item => {
          this.restApiOptions = res;
          if (labelField) {
            let existOptions = options.map(item => item.value);
            let val = valueFieldExt ? `${item[valueField]}@${item[valueFieldExt]}`: item[valueField];
            if(!existOptions.includes(val)) {
              options.push({
                label: item[labelField],
                value: val
              })
            }
            return;
          }
          if (valueField) {
            if (!options.includes(item[valueField]))
              options.push(item[valueField]);
          } else {
            options.push(item);
          }
        })
        this.options = options;
      }).finally(() => {
        this.isLoading = false;
        resolve();
      });
    })
  }

  selected(e) {
    this.optionSelected.emit(e);
  }
  inputFocus(e){
    e.currentTarget.blur();
  }

}
